import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'
import localStorage from 'utils/localStorage'

/**
 * Type Interface for the body of the forget password otp request
 */
export interface ForgetBody {
	email: string
}

/**
 * Type Definition for the Response you get from the OTP request for reset passeord
 */
export interface RecoveryEmailResponse {
	token: string
}

const ForgetPasswordEmail = async (body: ForgetBody) => {
	try {
		const { data } = await axios.post<RecoveryEmailResponse>(
			'management/forget',
			body
		)
		localStorage.set('token', data.token)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default ForgetPasswordEmail
